import {useCallback} from "react";
import {Button, Dialog, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useFormikContext} from "formik";
import {FormValuesType} from "../model/model";
import {useRecoilState} from "recoil";
import {buttonConfirmedState, entityTerminatedState, formEditingState, idEntityState} from "../model/state";
import {restContractorService} from "../service/restServiceController";
import {DMS_ENTITY} from "../model/data";

// Gestione delle ins/del e mod per tutte le form
const DialogConfirm = ({ open, setOpen, data }: {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    data?: any
}) => {
    const {t} = useTranslation(['network', 'translation']);
    const baseUrl = '/network/contractor';

    // Use Formik Context
    const {values, submitForm, isSubmitting} = useFormikContext<FormValuesType>();

    const [getButtonName, setButtonName] = useRecoilState(buttonConfirmedState);

    const [, setEntityTerminatedState] = useRecoilState(entityTerminatedState);

    const [getIdEntity, setIdEntity] = useRecoilState(idEntityState)

    const [editingForm, setFormEditingState] = useRecoilState(formEditingState);

    // Use Callback
    const getMissingFieldMessages = useCallback(() => {
        const messages: string[] = []
        //
        // const dmsType = data.type;
        // if (data.companyName.length < 3 && !_.isEmpty(data.companyName))
        //     messages.push('Missing "Company Name" in Company Name field.');
        //
        // if (data.type !== ("APT" || "RA" || "CA" || "Other") || _.isEmpty(data.type))
        //     messages.push('Missing "Type" in Type field.');
        //
        // // TODO: add message for error in form
        return messages;
    }, [data]);

    const onClickConfirm = useCallback(() => {
        submitForm();

        if (getButtonName === 'confirm')
            restContractorService(values, 'insert', baseUrl, '', getIdEntity ).then( () => {
                setFormEditingState(0);
            })

        if (getButtonName === 'terminate') {
            setEntityTerminatedState(true);
            restContractorService(values, 'delete', baseUrl + "/", DMS_ENTITY.data.id)
        }

        setOpen(false);
        setButtonName('');

    }, [getButtonName]);

    return (
        <Dialog open={open}>
            <Grid container p={2} rowSpacing={2}>
                {
                    getButtonName === 'confirm' ?
                        <Grid item xs={12}>
                            {
                                getMissingFieldMessages().map((message, i) => (
                                    <Typography key={i} color="red">{message}</Typography>
                                ))}
                        </Grid>
                        : null
                }
                {/*<Grid item xs={12}>*/}
                {/*    <Typography fontWeight={500}>Do you confirm*/}
                {/*        action? {getButtonName.toString() + JSON.stringify(data)}</Typography>*/}
                {/*</Grid>*/}
                <Grid item xs={12}>
                    <Typography variant="bodyLarge">
                        {t("contractorMng.dialogConfirm.title")}
                    </Typography>
                </Grid>
                <Grid item container xs={12} justifyContent="end" columnGap={1}>
                    <Button onClick={onClickConfirm} disabled={isSubmitting}>{t("contractorMng.dialogConfirm.action.confirm")}</Button>
                    <Button variant='outlined' onClick={() => setOpen(false)}>{t("contractorMng.dialogConfirm.action.cancel")}</Button>
                </Grid>
            </Grid>
        </Dialog>

    );
};

export default DialogConfirm;